export const CITY_TIPS_TEST_CITIES = {
    'san-diego-ca': true,
    'bakersfield-ca': true,
    'charlotte-nc': true,
    'jacksonville-fl': true,
    'santa-barbara-ca': true,
    'houston-tx': true,
    'chicago-il': true,
    'atlanta-ga': true,
    'orlando-fl': true,
    'colorado-springs-co': true,
    'denver-co': true,
    'salt-lake-city-ut': true,
    'seattle-wa': true,
    'phoenix-az': true,
    'portland-or': true,
    'nashville-tn': true,
    'san-antonio-tx': true,
    'san-jose-ca': true,
};
